import { Components, Theme } from '@mui/material';

export const MuiLinearProgress: Components<
  Omit<Theme, 'components'>
>['MuiLinearProgress'] = {
  styleOverrides: {
    root: ({ theme }) => {
      return {
        borderRadius: theme.shape.borderRadius,
        height: '8px',
        backgroundColor: theme.palette.primary.onColorFixedDim,
        '& .MuiLinearProgress-bar': {
          borderRadius: '8px',
          backgroundColor: theme.palette.primary.onColorFixedVar,
        },
      };
    },
  },
};
